import { FC, ReactElement } from 'react';
import { Form, FormInstance } from 'antd';
import { Typography, Input, PhoneNumber } from 'iglooform';

type FormPorps = {
  formInstance: FormInstance;
};

const AddCustomer: FC<FormPorps> = (props: FormPorps): ReactElement => {
  const { formInstance } = props;
  return (
    <div>
      <Form form={formInstance} layout="vertical">
        <Typography level="body1">Full Name</Typography>
        <Form.Item
          key={'0'}
          name={'name'}
          rules={[{ required: true, message: 'Please input Full Name!' }]}
        >
          <Input></Input>
        </Form.Item>
        <Typography level="body1">Mobile Number</Typography>
        <Form.Item
          key={'1'}
          name={'phoneNumber'}
          rules={[{ required: true, message: 'Please input a Mobile Number!' }]}
        >
          <PhoneNumber areaCode="+84"></PhoneNumber>
        </Form.Item>
        <Typography level="body1">Email</Typography>
        <Form.Item
          key={'2'}
          name={'email'}
          rules={[{ required: true, message: 'Please input a email!' }]}
        >
          <Input></Input>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddCustomer;
